<template>
  <div>
    <p>
      <span class="title">Количество клубов</span><br>
      {{stat.clubsAmount | getFormattedNumber}}
    </p>
    <p>
      <span class="title">Количество игроков</span><br>
      {{stat.participantAmount | getFormattedNumber}}
    </p>
    <p>
      <span class="title">Количество игроков, которые получили 0 кубков</span><br>
      {{viewersAmount | getFormattedNumber}}
    </p>
    <p>
      <span class="title">Количество игроков, которые получили 1 кубок или больше</span><br>
      {{stat.realParticipantAmount | getFormattedNumber}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TmntChestStat',

  props: {
    stat: {
      type: Object,
      required: true,
    },
  },

  computed: {
    viewersAmount() {
      return this.stat.participantAmount - this.stat.realParticipantAmount;
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 1rem;
}

.title {
  font-weight: bold;
}
</style>